import { ChangeEvent, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import tw from 'twin.macro';

import { useInsightsContext } from '@insights_module/context/InsightsContext';
import { useInsightsParams } from '@insights_module/hooks/useInsightsParams';
import { useDebouncedState } from '@app/hooks/useDebounce';
import { AppliedFilters } from '@insights_module/components/filters/AppliedFilters';
import { SidebarToggleButton } from '@insights_module/components/SidebarToggleButton';
import { FiltersIcon } from '@icons/FiltersIcon';
import { SearchIcon } from '@icons/SearchIcon';

const HeaderContainer = tw.div`flex items-center justify-between gap-[8px] min-h-[41px] bg-neutral-background border-b border-solid border-gray-1 sticky top-0 z-10 px-[24px]`;
const ContentHeaderButton = tw.button`border border-solid border-gray-1 px-[10px] text-text-and-icon text-[11px] rounded-[4px] h-[26px]`;

export const LibraryTableHeader = () => {
  const { t } = useTranslation();
  const { showFiltersModal, setShowFiltersModal } = useInsightsContext();

  const { searchTerm: urlSearchTerm, setSearchTerm: setUrlSearchTerm } = useInsightsParams();
  const [searchTerm, setSearchTerm] = useState(urlSearchTerm || '');
  const debouncedValue = useDebouncedState(searchTerm, 250);

  useEffect(() => {
    setUrlSearchTerm(debouncedValue);
  }, [debouncedValue]);

  const handleSearch = (e: ChangeEvent<HTMLInputElement>) => {
    const { target } = e;

    setSearchTerm(target.value);
  };

  return (
    <HeaderContainer>
      <SidebarToggleButton tw='mr-[8px]' />

      <div tw='flex items-center gap-[8px] justify-between w-full relative'>
        <SearchIcon tw='absolute left-[12px] stroke-text-and-icon-muted' />
        <input
          type='text'
          name='library-search-term'
          placeholder='Search'
          value={searchTerm as string}
          tw='inline-block bg-neutral-background border border-solid border-gray-1 rounded-[4px] px-[10px] text-[11px] placeholder:text-[11px] h-[26px] pl-[34px] text-text-and-icon'
          onChange={(e) => handleSearch(e)}
        />

        <ContentHeaderButton
          tw='flex items-center gap-[6px]'
          onClick={() => setShowFiltersModal(!showFiltersModal)}>
          <FiltersIcon tw='stroke-text-and-icon' />
          {t('insights.my_library_page.view.filters')}
        </ContentHeaderButton>
      </div>
      <AppliedFilters />
    </HeaderContainer>
  );
};
